module.exports = __webpack_public_path__ + "img/icon_sm_ccp.b7d9d458.png";